<ul class="ne-notifications">
  {#each notifications as notification (notification.id)}
    <span in:fly="{{y: -200, duration: 200, delay: 200}}" out:fly="{{x: 200, duration: 200}}">
      <Notification remove="{event => remove(event)}" {notification} />
    </span>
  {/each}
</ul>

<style>
  :global(.ne-notifications) {
    list-style: none;
    margin: 0;
    padding: 1em;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: 768px) {
    :global(.ne-notifications) {
      align-items: flex-end;
      left: auto;
      min-width: 30vw;
      max-width: 480px;
    }
  }
</style>

<script>
  import Notification from './Notification.html';
  import { fly } from 'svelte-transitions';
  import { onDestroy } from 'svelte';

  export let notifications = [];
  export let timers = [];
  export let count = 0;
  export let types = {};
  export let removeCallback = null;

  onDestroy(() => {
    timers.forEach(clearTimeout);
  });

  function add(message, type, ms) {
    if (ms > 0) {
      const timerId = window.setTimeout(() => {
        remove(count);
        window.clearTimeout(timerId);
        timers = timers.filter(t => t === timerId);
      }, ms);

      timers = timers.concat([timerId]);
    }

    notifications = notifications.concat([{ id: count, message, type }]);
    count = count + 1;
  };

  export function clearAll() {
    timers.forEach(clearTimeout);

    notifications = [];
    timers = [];
    count = 0;
  };

  export function remove(id) {
    if (removeCallback) {
      removeCallback(id);
    } else {
      notifications = notifications.filter(t => t.id !== id);
    }
  };

  export function success(message, ms) {
    add(message, 'success', ms);
  };

  export function warning(message, ms) {
    add(message, 'warning', ms);
  };

  export function error(message, ms) {
    add(message, 'error', ms);
  };
</script>
